<template>
  <v-app>
    <v-main class="auth-bg">
      <v-container fluid fill-height>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="10" md="6" lg="4">
            <div class="text-center mb-8">
              <BrandLogo />
              <p class="subtitle-1 mt-4" style="color: #5f6368">
                Nueva contraseña
              </p>
            </div>

            <v-card class="auth-card elevation-1" rounded="lg">
              <v-card-text class="pa-10">
                <template v-if="!done">
                  <v-form ref="form" v-model="valid" @submit.prevent="handleSubmit">
                    <v-text-field
                      v-model="password"
                      label="Nueva contraseña"
                      :type="showPassword ? 'text' : 'password'"
                      outlined
                      dense
                      :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                      @click:append="showPassword = !showPassword"
                      :rules="passwordRules"
                      :disabled="loading"
                      autocomplete="new-password"
                      hint="Mínimo 8 caracteres, 1 mayúscula, 1 número"
                      persistent-hint
                      hide-details="auto"
                    />

                    <v-text-field
                      v-model="passwordConfirm"
                      label="Confirmar contraseña"
                      :type="showPasswordConfirm ? 'text' : 'password'"
                      outlined
                      dense
                      :append-icon="showPasswordConfirm ? 'mdi-eye-off' : 'mdi-eye'"
                      @click:append="showPasswordConfirm = !showPasswordConfirm"
                      :rules="confirmRules"
                      :disabled="loading"
                      autocomplete="new-password"
                      class="mt-4"
                      hide-details="auto"
                    />

                    <v-btn
                      block
                      x-large
                      color="primary"
                      type="submit"
                      :loading="loading"
                      :disabled="!valid || loading"
                      class="mt-6 text-none font-weight-medium"
                      elevation="0"
                    >
                      Cambiar contraseña
                    </v-btn>
                  </v-form>

                  <v-alert
                    v-if="error"
                    type="error"
                    dense
                    text
                    dismissible
                    @input="error = null"
                    class="mt-4 mb-0"
                  >
                    {{ error }}
                  </v-alert>
                </template>

                <template v-else>
                  <div class="text-center">
                    <v-icon size="56" color="success" class="mb-4">mdi-check-circle-outline</v-icon>
                    <h3 class="text-h6 font-weight-medium mb-3" style="color: #202124">
                      Contraseña actualizada
                    </h3>
                    <p class="body-2 mb-6" style="color: #5f6368">
                      Tu contraseña se ha cambiado correctamente. Ya puedes iniciar sesión.
                    </p>
                    <v-btn
                      color="primary"
                      class="text-none font-weight-medium"
                      @click="$router.push('/signin')"
                      elevation="0"
                    >
                      Iniciar sesión
                    </v-btn>
                  </div>
                </template>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script lang="ts">
import Vue from 'vue';
import { supabase } from '@/services/supabase';
import BrandLogo from '@/components/brand/BrandLogo.vue';

export default Vue.extend({
  name: 'ResetPasswordView',
  components: { BrandLogo },
  data() {
    return {
      valid: false,
      password: '',
      passwordConfirm: '',
      showPassword: false,
      showPasswordConfirm: false,
      loading: false,
      done: false,
      error: null as string | null,
      passwordRules: [
        (v: string) => !!v || 'La contraseña es requerida',
        (v: string) => v.length >= 8 || 'Mínimo 8 caracteres',
        (v: string) => /[A-Z]/.test(v) || 'Debe contener al menos una mayúscula',
        (v: string) => /[0-9]/.test(v) || 'Debe contener al menos un número',
      ],
    };
  },
  computed: {
    confirmRules(): Array<(v: string) => boolean | string> {
      return [
        (v: string) => !!v || 'Confirma tu contraseña',
        (v: string) => v === this.password || 'Las contraseñas no coinciden',
      ];
    },
  },
  methods: {
    async handleSubmit() {
      if (!this.valid) return;
      this.loading = true;
      this.error = null;

      try {
        const { error } = await supabase.auth.updateUser({
          password: this.password,
        });
        if (error) throw error;
        this.done = true;
      } catch (err: any) {
        this.error = err.message || 'Error al cambiar la contraseña. El enlace puede haber expirado.';
      } finally {
        this.loading = false;
      }
    },
  },
});
</script>

<style scoped>
.auth-bg {
  background: var(--casa-fondo-app);
  min-height: 100vh;
}

.auth-card {
  border: 1px solid var(--casa-borde-fuerte);
  max-width: 450px;
  margin: 0 auto;
}
</style>
